"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixOldPRFilters = exports.updateFiltersForDataConfig = exports.getValidDataPlatformFilter = void 0;
var type_narrowing_1 = require("@shared/utils/type-narrowing");
var lodash_1 = __importDefault(require("lodash"));
function getValidDataPlatformFilter(sourceId, filters) {
    var _a;
    return type_narrowing_1.hasProperty(filters, 'type')
        ? filters
        : (_a = filters === null || filters === void 0 ? void 0 : filters[sourceId]) !== null && _a !== void 0 ? _a : {};
}
exports.getValidDataPlatformFilter = getValidDataPlatformFilter;
/**
 * Hide empty values from a results table based on these conditions:
 * 1. showEmptyValues is false
 * 2. Data has one column
 * 3. Data value is not undefined
 */
function shouldHideEmptyValues(dataConfig) {
    return !dataConfig.showEmptyValues && dataConfig.fields.length === 1;
}
/**
 * Adds a filter to hide empty values if the dataConfig meets shouldHideEmptyValues conditions.
 * This logic only applies to results tables.
 */
function updateFiltersForDataConfig(filters, dataConfig) {
    if (type_narrowing_1.hasProperty(filters, 'children') && shouldHideEmptyValues(dataConfig)) {
        var hideFilter = {
            filter: {
                field: dataConfig.fields[0],
                operand: true,
                operator: 'present'
            },
            type: "filter" /* FILTER */
        };
        filters.children.push(hideFilter);
    }
    return filters;
}
exports.updateFiltersForDataConfig = updateFiltersForDataConfig;
// TODO: Add types
function fixOldPRFilters(originalFilters) {
    var NO_OPERAND = ['isEmptyText', 'isNotEmptyText', 'isEmpty', 'isNotEmpty'];
    var filters = originalFilters;
    if (lodash_1.default.isEmpty(filters)) {
        return {};
    }
    if (!lodash_1.default.isEmpty(filters.children)) {
        lodash_1.default.forEach(filters.children, function (currFilter) {
            fixOldPRFilters(currFilter);
        });
        return filters;
    }
    // If for some reason there isn't a filter set but there are no children, just return
    if (!filters.filter) {
        return filters;
    }
    // If there is no operand and it should have one we want to filter these out
    if (!filters.filter.dateRange && !lodash_1.default.includes(NO_OPERAND, filters.filter.operator) &&
        lodash_1.default.isUndefined(filters.filter.operand)) {
        delete filters.filter;
    }
    else if (filters.filter.operator === 'between' && filters.filter.operand.start && filters.filter.operand.end) {
        filters.filter.operand = [filters.filter.operand.start, filters.filter.operand.end];
    }
    else if (lodash_1.default.includes(['isEmptyText', 'isNotEmptyText'], filters.filter.operator)) {
        filters.filter.operand = lodash_1.default.isUndefined(filters.filter.operand) ?
            filters.filter.operator === 'isEmptyText' : filters.filter.operand;
        filters.filter.operator = 'isEmptyText';
    }
    else if (lodash_1.default.includes(['isEmpty', 'isNotEmpty'], filters.filter.operator)) {
        filters.filter.operand = lodash_1.default.isUndefined(filters.filter.operand) ?
            filters.filter.operator === 'isNotEmpty' : filters.filter.operand;
        filters.filter.operator = 'present';
    }
    return filters;
}
exports.fixOldPRFilters = fixOldPRFilters;
